import { Link, Outlet } from "react-router-dom";
import { useState } from "react";
import Navbar from "../components/Dashboard/Navbar";
import AuthFooter from "../components/Login/AuthFooter";
import GlobalAuthLoader from "../components/Login/GlobalAuthLoader";
import ScrollToTop from "../components/Common/ScrollToTop";
import useSessionMonitor from "../hooks/useSessionMonitor";
import { LoggedUserProvider } from "../contexts/LoggedUserContext";

const DashboardRoot = ({ showLogo = true }) => {
  useSessionMonitor();
 const [isCrateOpen, setIsCrateOpen] = useState(false);
 
  return (
    <div>
      <LoggedUserProvider>
        <GlobalAuthLoader />
        <Navbar />
        
        {/* Main Content Container */}
        <div className="flex-1 flex flex-col">
          {/* Background Container */}
          <div className="relative bg-black-blue-radial bg-fixed bg-no-repeat bg-cover text-white flex-1 flex flex-col">
            <div
              className="pointer-events-none fixed bottom-0 left-1/2 -translate-x-1/2 w-screen h-[100px] rounded-full blur-[100px] opacity-40 z-0"
              style={{ backgroundColor: "rgba(25, 122, 208, 0.9)" }}
            />
            <div
              className="pointer-events-none fixed bottom-0 left-[5%] w-[30vw] max-w-[414px] h-[100px] rounded-full blur-[118px] opacity-30 z-0"
              style={{ backgroundColor: "rgba(82, 250, 240, 0.7)" }}
            />
            
            {/* Main Content Area - Dashboard pages*/}
            <div className="flex-1 flex justify-center items-start pt-6 sm:pt-20 relative z-10 pb-16">
              <div className="w-full max-w-6xl px-1 sm:px-4">
                <ScrollToTop />
                <Outlet />
              </div>
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <div className="relative">
          <AuthFooter />
        </div>
      </LoggedUserProvider>
    </div>
  );
};

export default DashboardRoot;